module.exports = __webpack_public_path__ + "img/0x48c40d4666f93408be1bef038b6722404d9a4c2a.4dbb3779.png";